import * as React from 'react';
import {
    Alert,
    Button, CircularProgress,
    Grid, InputAdornment,
    TextField, Tooltip
} from "@mui/material";
import {
    ArrowBackIos, ArrowDropDown, ArrowForwardIos, Key, Mail, Person, Phone,
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useEffect, useRef, useState} from "react";
import {selectRequestState, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../inc/Api";
import Pref from "../../inc/Pref";
import {userLoggedIn} from "../../store/userSlice";
import Typography from "@mui/material/Typography";
import {flagEmoji, stg} from "../../inc/Utils";
import CCountry from "../../app/global/CCountry";

function Step3Register() {

    const {item} = useSelector(selectRequestState);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rsp, setRsp] = useState(null);
    const [country, setCountry] = useState(null);
    const cCountryM = useRef(null);

    const [data, setData] = useState({
        name    : '',
        surname : '',
        password: '',
        phone   : '',
    });

    useEffect(loadData, []);

    function loadData() {
        setRsp(null);
        Api.get('/client/auth/form', r => {
            setRsp(r);
            if (r.ok) {
                setCountry(r.countries.find(c => c.iso === stg.country_code) || r.countries[0]);
            }
        });
    }

    function register() {

        setLoading(true);
        setError(null);
        Api.post('/client/auth/register', {
            ...data,
            phone    : `+${country.code}${data.phone}`,
            email    : item.client.email,
            id_widget: item.id_widget,
        }, rsp => {
            if (rsp.ok) {

                // logica de login
                Pref.sessionToken = rsp.token;

                verify();

            } else {
                setLoading(false);
                setError(rsp.msg);
            }
        });

    }

    function verify() {
        Api.get('/admin/verify', rsp => {
            if (rsp.ok && rsp.user.data) {
                Pref.sessionUser = rsp.user.data;
                dispatch(userLoggedIn(rsp.user.data));
                console.log('rsp.user.data', rsp.user.data);
                dispatch(setStep('4'));
            } else {
                console.log('no logged');
            }
        });
    }

    return (
        <Body title="Crear una cuenta" onSubmit={register}>

            {rsp == null ? (
                <div style={{textAlign: 'center'}}>
                    <CircularProgress/>
                </div>
            ) : !rsp.ok ? (
                <div>
                    <Alert severity="error">{rsp.msg}</Alert>
                </div>
            ) : (
                <Grid container spacing={3}>

                    <Grid xs={12} sm={6} item>

                        <TextField
                            label="Teléfono"
                            name="phone"
                            value={data.phone}
                            onChange={e => setData({...data, phone: e.target.value})}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Button
                                            onClick={() => {
                                                cCountryM.current.choose(rsp.countries, co => {
                                                    setCountry(co);
                                                });
                                            }}
                                            size="small"
                                            style={{
                                                padding : '2px 0 2px 4px',
                                                minWidth: 'unset',
                                            }}>
                                            <Tooltip title={country.name}>
                                                <Typography color="textPrimary">
                                                    {flagEmoji(country.iso)}

                                                    <ArrowDropDown fontSize="small" style={{
                                                        verticalAlign: 'middle',
                                                    }}/>
                                                </Typography>
                                            </Tooltip>
                                        </Button>

                                        +{country.code}

                                    </InputAdornment>
                                ),
                                endAdornment  : (
                                    <InputAdornment position="end">
                                        <Phone color="primary"/>
                                    </InputAdornment>
                                ),
                            }}
                            disabled={loading}
                            autoFocus/>

                    </Grid>

                    <Grid xs={12} sm={6} item>

                        <TextField
                            label="Nombre"
                            name="name"
                            value={data.name}
                            onChange={e => setData({...data, name: e.target.value})}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Person color="primary"/>
                                    </InputAdornment>
                                ),
                            }}
                            disabled={loading}/>

                    </Grid>

                    <Grid xs={12} sm={6} item>

                        <TextField
                            label="Apellido"
                            name="surname"
                            value={data.surname}
                            onChange={e => setData({...data, surname: e.target.value})}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Person color="primary"/>
                                    </InputAdornment>
                                ),
                            }}
                            disabled={loading}/>

                    </Grid>

                    <Grid xs={12} sm={6} item>

                        <TextField
                            label="Correo electrónico"
                            name="email"
                            value={item.client.email}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Mail color="primary"/>
                                    </InputAdornment>
                                ),
                            }}
                            disabled/>

                    </Grid>

                    <Grid xs={12} sm={6} item>

                        <TextField
                            label="Contraseña"
                            name="password"
                            value={data.password}
                            onChange={e => setData({...data, password: e.target.value})}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Key color="primary"/>
                                    </InputAdornment>
                                ),
                            }}
                            type="password"
                            autoComplete="new-password"
                            disabled={loading}/>

                    </Grid>

                    <Grid sm={6} item display={{xs: 'none', sm: 'block'}}/>

                    {error && (
                        <Grid xs={12} item>
                            <Alert severity="error">{error}</Alert>
                        </Grid>
                    )}

                    <Grid sm={6} item display={{xs: 'none', sm: 'block'}}/>

                    <Grid xs={6} sm={3} item>

                        <Button
                            variant="contained"
                            startIcon={<ArrowBackIos/>}
                            onClick={() => {
                                dispatch(setStep('3_check'));
                            }}
                            color="secondary"
                            disabled={loading}
                            fullWidth>
                            Volver
                        </Button>

                    </Grid>

                    <Grid xs={6} sm={3} item>

                        <Button
                            variant="contained"
                            endIcon={!loading && <ArrowForwardIos/>}
                            type="submit"
                            disabled={!item.client.email || loading}
                            fullWidth>
                            {loading ? 'Verificando...' : 'Siguiente'}
                        </Button>

                    </Grid>

                </Grid>
            )}

            <CCountry ref={cCountryM}/>

        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step3Register));